<template>
  <v-container id="signinup-form" class="fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="8" class>
        <v-card class="evelation-12 card">
          <v-window v-model="step">
            <!--SignIn-->
            <v-window-item :value="1">
              <v-row class>
                <v-col cols="12">
                  <v-card-text>
                    <v-form class="signup-form-form" @submit.prevent="login">
                      <h1
                        class="text-center display-1 mb-10"
                        :class="`${bgColor}--text`"
                      >
                        Sign in
                      </h1>
                      <v-text-field
                        id="email"
                        v-model="email"
                        label="Email"
                        name="email"
                        append-icon="person"
                        type="text"
                        :color="bgColor"
                      />
                      <v-text-field
                        id="password"
                        v-model="password"
                        label="Password"
                        name="Password"
                        append-icon="lock"
                        type="password"
                        :color="bgColor"
                      />
                      <div class="text-center">
                        <v-alert
                          dense
                          outlined
                          type="error"
                          v-if="errorMessage != ''"
                        >
                          {{ errorMessage }}
                        </v-alert>
                        <a
                          href="#"
                          class="mt-3 overline no-text-decoration"
                          :class="`${bgColor}--text`"
                          @click="step = 3"
                          >Forgot your password?</a
                        >
                      </div>
                      <vue-recaptcha
                        :sitekey="sitekey"
                        @verify="mxVerify"
                        class="mt-3"
                        style="text-align: -webkit-center;"
                      ></vue-recaptcha>
                      <div class="text-center mt-3">
                        <v-btn
                          type="submit"
                          large
                          v-if="!signIn_Loader"
                          :color="bgColor"
                          :dark="!recaptcha ? false : true"
                          :disabled="!recaptcha"
                        >
                          Sign In
                        </v-btn>
                        <v-progress-circular
                          indeterminate
                          color="red"
                          v-else-if="signIn_Loader"
                        ></v-progress-circular>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueRecaptcha } from 'vue-recaptcha';
import { mapActions } from 'vuex';

export default {
  name: 'login',
  components: {
    VueRecaptcha,
  },
  props: {
    source: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: 'indigo',
    },
    fgColor: {
      type: String,
      default: 'white',
    },
  },
  async fetch({ store, error }, user) {
    try {
      await store.dispatch('users/signupUser', user);
    } catch (e) {
      error({
        statusCode: 503,
        message: 'Unable to sign up user. Please try again later.',
      });
    }
  },
  data: () => ({
    step: 1,
    email: '',
    password: '',
    snackbar: false,
    errorMessage: '',
    signIn_Loader: false,
    recaptcha: null,
    sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
  }),
  methods: {
    ...mapActions(['retrieveToken']),
    mxVerify(response) {
      this.recaptcha = response;
    },
    login() {
      if (this.recaptcha) {
        this.signIn_Loader = true;
        this.retrieveToken({
          email: this.email,
          password: this.password,
        })
          .then(() => {
            this.$router.push({ name: 'routes' });
          })
          .catch((err) => {
            this.signIn_Loader = false;
            this.errorMessage = this.errors;
            console.log(err);
          });
      }
    },
  },
  computed: {
    ...mapGetters(['errors']),
  },
};
</script>

<style scoped lang="scss">
a.no-text-decoration {
  text-decoration: none;
}
#signinup-form {
  max-width: 45rem;
}
.signup-form-form {
  max-width: 23rem;
  margin: 0 auto;
}
.card {
  overflow: hidden;
}
.vcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
